import Head from "next/head";
import siteConfig from "../lib/siteConfig";

export default function Meta({ pageContent = {}, url = siteConfig.siteUrl }) {
  const title =
    pageContent?.seo?.seoTitle ||
    pageContent?.title ||
    siteConfig.meta.defaultTitle;
  const description =
    pageContent?.seo?.seoDescription || siteConfig.meta.defaultDescription;
  const image = `${url}/elainlaakariasema-sinni-og-image.png`;

  return (
    <Head>
      <title>{String(title)}</title>
      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Preconnect to Sanity CDN */}
      <link rel="preconnect" href="https://cdn.sanity.io" crossorigin />

      {/* Icons */}
      <link rel="icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
      <link
        rel="icon"
        type="image/png"
        sizes="192x192"
        href="/android-chrome-192x192.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="512x512"
        href="/android-chrome-512x512.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
      />
      <link rel="manifest" href="/site.webmanifest" />
    </Head>
  );
}
